var map = {
	"./titar.png": "h6ra",
	"./titen.png": "FrK1",
	"./titkhm.png": "UGYF",
	"./titthai.png": "6PeM",
	"./titvi.png": "g7EQ",
	"./titzh-tw.png": "8fA0"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "W+Yg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/entry/img ^\.\/tit.*\.png$
// module id = W+Yg
// module chunks = 1